import React from "react";

/**
 * Route-level error boundary. Prevents a single component error from rendering
 * a blank white page — surfaces the failure and offers a recovery path.
 */
export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        // eslint-disable-next-line no-console
        console.error("ErrorBoundary caught:", error, info);
    }

    handleReset = () => {
        this.setState({ hasError: false, error: null });
    };

    render() {
        if (!this.state.hasError) return this.props.children;
        const message = this.state.error?.message || "Something went wrong while rendering this page.";
        return (
            <div className="min-h-[60vh] flex items-center justify-center px-6 py-12" data-testid="error-boundary">
                <div className="max-w-lg border border-rose-200 bg-rose-50 rounded-lg p-6">
                    <div className="text-xs uppercase tracking-widest text-rose-700">Page error</div>
                    <h2 className="font-heading text-xl font-semibold text-slate-900 mt-1" data-testid="error-boundary-title">
                        We couldn&apos;t render this page
                    </h2>
                    <p className="text-sm text-slate-700 mt-3" data-testid="error-boundary-message">{message}</p>
                    <div className="mt-4 flex items-center gap-3 text-sm">
                        <button
                            type="button"
                            onClick={this.handleReset}
                            className="px-3 py-1.5 rounded-md border border-slate-300 bg-white hover:bg-slate-50"
                            data-testid="error-boundary-retry"
                        >
                            Try again
                        </button>
                        <a href="/" className="text-slate-700 underline" data-testid="error-boundary-home">Go to dashboard</a>
                    </div>
                </div>
            </div>
        );
    }
}
